module.exports = __webpack_public_path__ + "static/media/Scene-kapak.1daea9fc.png";